import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const IndentIn = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33366 4.16675C4.33366 3.89061 4.55751 3.66675 4.83366 3.66675H12.167C12.4431 3.66675 12.667 3.89061 12.667 4.16675C12.667 4.44289 12.4431 4.66675 12.167 4.66675H4.83366C4.55751 4.66675 4.33366 4.44289 4.33366 4.16675ZM3.81344 9.85363C3.61818 9.65837 3.61818 9.34179 3.81344 9.14653L4.79322 8.16675L3.81344 7.18697C3.61818 6.99171 3.61818 6.67512 3.81344 6.47986C4.0087 6.2846 4.32528 6.2846 4.52055 6.47986L5.85388 7.81319C6.04914 8.00846 6.04914 8.32504 5.85388 8.5203L4.52055 9.85363C4.32528 10.0489 4.0087 10.0489 3.81344 9.85363ZM8.16699 6.33341C7.89085 6.33341 7.66699 6.55727 7.66699 6.83341C7.66699 7.10956 7.89085 7.33341 8.16699 7.33341H12.167C12.4431 7.33341 12.667 7.10956 12.667 6.83341C12.667 6.55727 12.4431 6.33341 12.167 6.33341H8.16699ZM7.66699 9.50008C7.66699 9.22394 7.89085 9.00008 8.16699 9.00008H12.167C12.4431 9.00008 12.667 9.22394 12.667 9.50008C12.667 9.77622 12.4431 10.0001 12.167 10.0001H8.16699C7.89085 10.0001 7.66699 9.77622 7.66699 9.50008ZM4.83366 11.6667C4.55751 11.6667 4.33366 11.8906 4.33366 12.1667C4.33366 12.4429 4.55751 12.6667 4.83366 12.6667H12.167C12.4431 12.6667 12.667 12.4429 12.667 12.1667C12.667 11.8906 12.4431 11.6667 12.167 11.6667H4.83366Z"
        fill={color}
      />
    </svg>
  )
})

export default IndentIn
